<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Stage</mat-label>
      <mat-select formControlName="caseType" [disabled]="isCaseTypeDisabled">
        <mat-option value="PreArrangement">
          Pre-Arrangement
        </mat-option>
        <mat-option value="Arrangement">
          Arrangement
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-checkbox formControlName="useExistingCaseData" class="m-b-10" [disabled]="(caseList$|async).length === 0">Use
      data from existing Case
    </mat-checkbox>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Case</mat-label>
      <mat-select [disabled]="inputForm.value.useExistingCaseData === false" formControlName="selectedCase">
        <mat-option *ngFor="let case of (caseList$|async)" [value]="case">
          {{case.displayText}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="inputForm.controls['caseType'].value === 'Arrangement'">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Reporting Frequencey</mat-label>
      <mat-select [disabled]="inputForm.value.useExistingCaseData === false" formControlName="selectedFiledPeriod">
        <mat-option *ngFor="let filedPeriod of (filedPeriodList$|async)" [value]="filedPeriod">
          {{filedPeriod.filedPeriodTitle}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" type="text" placeholder="Title" #title>
      <mat-error *ngIf="inputForm.controls['title'].hasError('required')">
        Title is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-checkbox formControlName="specifyField" class="m-b-10"
                  [disabled]="inputForm.value.useExistingCaseData === false">Let me specify which data to include
    </mat-checkbox>
  </div>
</form>
